/**
 * IconButton
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import Icon from '../Icon/Icon';
/** Main description for this component. */
var IconButton = function (_a) {
    var icon = _a.icon, heading = _a.heading, _b = _a.tag, tag = _b === void 0 ? 'button' : _b, _c = _a.url, url = _c === void 0 ? '#' : _c, onClick = _a.onClick, id = _a.id, children = _a.children, props = __rest(_a, ["icon", "heading", "tag", "url", "onClick", "id", "children"]);
    var iconCss = clsx('border-2', 'bg-secondaryButton-bg-color', 'border-borderColor', 'text-secondaryButton-text-color', 'group-hover:bg-secondaryButton-hover-color', 'inline-block', 'outline-none', 'rounded-full', 'h-10', 'px-3', 'text-lg');
    var renderIcon = function () {
        return (React.createElement("div", { className: "flex items-center" },
            React.createElement("div", { className: clsx(iconCss, 'flex items-center') },
                React.createElement("span", null,
                    React.createElement(Icon, { icon: icon, color: "#00636A", size: 0.875 }))),
            heading && (React.createElement("h2", { className: "text-p text-teal group-hover:underline ml-2" }, heading))));
    };
    return (React.createElement(React.Fragment, null, tag === 'a' ? (React.createElement("a", __assign({ href: url, "data-cid": "IconButton", className: "inline-block group", id: id }, props),
        renderIcon(),
        children && React.createElement("div", { className: "text-left ml-13 -mt-3" }, children))) : (React.createElement("button", __assign({ onClick: onClick, "data-cid": "IconButton", className: "group", id: id }, props),
        renderIcon(),
        children && React.createElement("div", { className: "text-left ml-13 -mt-3" }, children)))));
};
export default IconButton;
